import { MapPin, BookOpen, Shield, List } from "lucide-react";
import { useState } from "react";

const Rules = () => {
  const [currentIdx, setCurrentIdx] = useState(null);
  const sections = [
    {
      title: "সংগঠনের গঠনতন্ত্র",
      subsections: [
        {
          title: "১ম ভাগঃ সংগঠনের পরিচিতি",
          content: [
            {
              title: "",
              description:
                "নিঃস্বার্থ নবজীবন সংগঠন (NNS), ২০১৩ সালে, চট্টগ্রাম জেলার চন্দনাইশ থানায়- কিছু স্বপ্নবাজ তরুণের উদ্দ্যোগে প্রতিষ্ঠিত। সমাজের অসহায়, নিঃস্ব, হতদরিদ্র মানুষগুলোর পাশে থাকার অঙীকার নিয়ে তাদের পথ চলা শুরু। ইহা সম্পূর্ণ অরাজনৈতিক, অলাভজনক, সামাজিক ও সেবামূলক সংগঠন। এই সংগঠনে ছাত্র, যুবকসহ যেকোনো শ্রেণী-পেশার মানুষ সদস্য হিসাবে যুক্ত আছেন।",
            },
            {
              title: "ধারা ১: সংগঠনের নাম",
              description:
                "বাংলায়ঃ নিঃস্বার্থ নবজীবন সংগঠন (NNS)\nইংরেজীতেঃ Niswartha Nabajibon Sanggathan",
            },
            {
              title: "ধারা ২: সংগঠনের পতাকা/লোগো",
              description:
                "সংগঠনের নির্দিষ্ট একটি লোগো আছে যা করমর্দন (হ্যান্ডশেক), সূর্যোদয়, সবুজ পাতা, নীল রঙ্গের 'NNS', প্রতিষ্ঠা সাল এই মোটিফ (চিহ্ন) নিয়ে সাজানো। এই মোটিফগুলো একতা, সহযোগিতা, নতুন জীবন, আশার আলো, বিশ্বস্ততা, পবিত্রতা, নিঃস্বার্থতার ও অন্ধকার দূর করার বার্তা বহন করে।",
            },
            {
              title: "ধারা ৩: স্লোগান",
              description:
                "'স্বার্থপর মানুষের ভিড়ে, নিঃস্বার্থভাবে আমরাই অবিচল' — এটি সংগঠনের নীতিকে শক্তিশালী করে তোলে।",
            },
            {
              title: "ধারা ৪: কার্য এলাকা",
              description: "সমগ্র বাংলাদেশ",
            },
            {
              title: "ধারা ৫: সংগঠনের ধরন ও বৈশিষ্ট্য",
              description:
                "অরাজনৈতিক, অলাভজনক, সামাজিক ও সেবামূলক সংগঠন। নিঃস্বার্থ নবজীবন সংগঠন (NNS) অসহায়, নিঃস্ব, নিপীড়িত মানুষ ও অনাথ পথশিশু তাদের অন্ন, বস্ত্র, শিক্ষা, চিকিৎসা ও বাসস্থান এই মৌলিক অধিকার নিশ্চিতসহ স্বাবলম্বীকরণ প্রজেক্টের মাধ্যমে একজন দক্ষ জনগোষ্ঠী তৈরিতে কাজ করে। এছাড়াও দূর্যোগকালীন পরিস্থিতিতে যেমন- করোনা মহামারিতে ও বন্যার সময় ত্রাণ বিতরণ কর্মসূচিসহ যেকোনো ক্রান্তিলগ্নে মানুষের সেবায় সর্বদা নিয়োজিত থাকে।",
            },
            {
              title: "ধারা ৬: সংগঠনের বিস্তারিত লক্ষ্য ও উদ্দেশ্য",
              points: [
                "অসহায়, নিঃস্ব ও সম্বলহীন মানুষদের মৌলিক অধিকার নিশ্চিত করা।",
                "স্বেচ্ছাসেবী ছাত্র/ছাত্রী, যুবক/যুবতী ও মানবপ্রেমীদের সংঘবদ্ধ করা।",
                "গরীব, মেধাবী ও অনাথ শিক্ষার্থীদের দক্ষ মানব শক্তিতে রুপান্তর করা।",
                "প্রাকৃতিক দুর্যোগ বা সংকটে ক্ষতিগ্রস্ত মানুষদের খাদ্য, চিকিৎসা ও আশ্রয় সহায়তা প্রদান।",
                "ভ্রাতৃত্ববোধ ও মানবিক মূল্যবোধ ছড়িয়ে দিয়ে শান্তিপূর্ণ সমাজ নির্মাণ।",
                "শিক্ষা কার্যক্রম পরিচালনা ও দারিদ্র্যপীড়িত অঞ্চলে শিক্ষার প্রসার ঘটানো।",
                "সুবিধাবঞ্চিত শিশুদের জন্য শিক্ষা উপকরণ ও বৃত্তি প্রদান।",
                "তরুণ সমাজকে স্বেচ্ছাসেবী কার্যক্রমে সম্পৃক্ত করে নেতৃত্বের উন্নয়ন সাধন।",
                "পরিবেশ রক্ষা, বৃক্ষরোপণ ও জলবায়ু পরিবর্তন মোকাবেলায় কার্যক্রম।",
                "সুবিধাবঞ্চিত শীতার্ত মানুষদের শীতবস্ত্র বিতরণ।",
              ],
            },
          ],
        },
        {
          title: "২য় ভাগঃ সদস্যপদ সংক্রান্ত",
          content: [
            {
              title: "ধারা ৭: সদস্যপদ গ্রহণের নিয়মাবলী",
              points: [
                "একজন সনাতনী ব্যক্তি সংগঠনের গঠনতন্ত্র জ্ঞাত হয়ে এবং সংগঠনের আদর্শ ও উদ্দেশ্য এর প্রতি পূর্ণ শ্রদ্ধা ও সম্মান রেখে (ভর্তি ফি ৫০, মাসিক ফি নূন্যতম ৫০ টাকা) জমা দিয়ে, সদস্য ফর্ম পূরণের মাধ্যমে সদস্য হওয়ার জন্য আবেদন করতে পারবেন। সংশ্লিষ্ট কমিটি যাচাই পূর্বক সদস্যতা অনুমোদন করবেন।",
                "কোন সদস্য রাষ্ট্র/সংবিধান বিরোধী কোন কার্যক্রমে জড়িত থাকতে পারবে না।",
                "নিয়মিত মাসিক প্রণামী (নূন্যতম ৫০ টাকা) পরিশোধ করবেন।",
              ],
            },
            {
              title: "ধারা ৮: সদস্যপদের ধরণ",
              subsections: [
                {
                  title: "ধারা ৮.১: প্রতিষ্টাতা সদস্য",
                  description:
                    "যাদের উদ্যোগে সংগঠনটি প্রতিষ্টিত হয়েছে তারাই প্রতিষ্টাতা সদস্য হিসেবে বিবেচিত হবেন। সাধারণ সদস্যদের ন্যায় তারা মাসিক/বার্ষিক চাঁদা পরিশোধ করবেন। তারাও সংগঠনের যে কোন কমিটিতে আসতে পারবেন।",
                },
                {
                  title: "ধারা ৮.২: সাধারণ সদস্য",
                  description:
                    "ধারা ৭ এর প্রেক্ষিতে সদস্যপদ প্রাপ্ত সকল সদস্যই সাধারণ সদস্য হিসেবে গণ্য হবে। সাধারণ সদস্যদের মতামত প্রকাশের অধিকার থাকবে। সংগঠনের সকল প্রতিষ্ঠাতা সদস্য ও আজীবন সদস্য, সাধারণ সদস্য হিসেবে গণ্য হবে।",
                },
                {
                  title: "ধারা ৮.৩: আজীবন সদস্য",
                  points: [
                    "তিন বছর ধরে মাসিক প্রনামী প্রদান করে গেলে সে সদস্য আজীবন সদস্য হিসেবে বিবেচিত হবে।",
                    "অথবা এককালীন ৩০০০/= টাকা প্রণামী প্রদান করে আজীবন সদস্যপদ লাভ করতে পারবেন এবং পরবর্তীতে তার সৎ ইচ্ছা থাকলে মাসিক প্রণামী চালিয়ে যেতে পারবেন।",
                  ],
                },
              ],
            },
            {
              title: "ধারা ৯: সদস্যপদ বাতিল সংক্রান্ত",
              description:
                "নিম্নে উল্লেখিত কারনে সদস্যের সদস্যপদ বাতিল হতে পারে:",
              points: [
                "একাধারে ২৪ মাস মাসিক প্রণামী প্রদান না করলে।",
                "স্বেচ্ছায় পদত্যাগ করলে।",
                "আদালত কর্তৃক সাজাপ্রাপ্ত হলে।",
                "পাগল কিংবা দেউলিয়া সাব্যস্ত হলে।",
                "সংগঠনের গঠনতন্ত্রের পরিপন্থী কোন কার্যকলাপে লিপ্ত হলে।",
                "রাষ্ট্র ও সমাজ বিরোধী কোন কাজে অংশগ্রহণ করলে।",
                "কেন্দ্রীয় কমিটি কারণ দর্শানোর সহিত সুপারিশে সেন্ট্রাল কমান্ড বিবেচনা পূর্বক সদস্যপদ বাতিল করতে পারবে।",
              ],
            },
          ],
        },
      ],
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-gray-50 py-8">
      <div className="container mx-auto px-4 max-w-5xl">
        {/* Header Section */}
        <div className="text-center mb-12">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-primary to-secondary">
              নিঃস্বার্থ নবজীবন সংগঠন (NNS)
            </span>
          </h1>
          <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-2">
            সংগঠনের গঠনতন্ত্র
          </h2>
          <p className="text-lg text-gray-600">
            একটি অরাজনৈতিক, অলাভজনক, সামাজিক ও সেবামূলক সংগঠন
          </p>
        </div>

        {/* Introduction Card */}
        <div className="card mb-10 shadow-lg border-0 bg-white/80 backdrop-blur-sm">
          <div className="card-body p-6 md:p-8">
            <div className="flex items-center gap-3 mb-4">
              <BookOpen className="h-6 w-6 text-blue-600" />
              <h3 className="text-xl font-semibold text-gray-800">পরিচিতি</h3>
            </div>
            <p className="text-gray-700 text-lg leading-relaxed mb-4">
              নিঃস্বার্থ নবজীবন সংগঠন (NNS), ২০১৩ সালে, চট্টগ্রাম জেলার চন্দনাইশ
              থানায়- কিছু স্বপ্নবাজ তরুণের উদ্দ্যোগে প্রতিষ্ঠিত। সমাজের অসহায়,
              নিঃস্ব, হতদরিদ্র মানুষগুলোর পাশে থাকার অঙীকার নিয়ে তাদের পথ চলা
              শুরু।
            </p>
            <p className="text-gray-700 text-lg leading-relaxed">
              ইহা সম্পূর্ণ অরাজনৈতিক, অলাভজনক, সামাজিক ও সেবামূলক সংগঠন। এই
              সংগঠনে ছাত্র, যুবকসহ যেকোনো শ্রেণী-পেশার মানুষ সদস্য হিসাবে যুক্ত
              আছেন।
            </p>
          </div>
        </div>

        {/* Rules Sections */}
        <div className="space-y-6">
          {sections[0].subsections.map((subsection, index) => (
            <div
              onClick={() => {
                if (index === currentIdx) {
                  setCurrentIdx(null);
                } else {
                  setCurrentIdx(index);
                }
              }}
              key={index}
              className="mb-8"
            >
              <div className="collapse collapse-arrow bg-white shadow-md hover:shadow-lg transition-all">
                <input type="checkbox" />
                <div
                  className={`collapse-title px-6 py-4 font-semibold text-lg ${
                    index % 4 === 0
                      ? "bg-blue-50 text-blue-700"
                      : index % 4 === 1
                      ? "bg-emerald-50 text-emerald-700"
                      : index % 4 === 2
                      ? "bg-amber-50 text-amber-700"
                      : "bg-purple-50 text-purple-700"
                  }`}
                >
                  <div className="flex items-center gap-3">
                    {index % 4 === 0 && <BookOpen className="h-5 w-5" />}
                    {index % 4 === 1 && <List className="h-5 w-5" />}
                    {index % 4 === 2 && <Shield className="h-5 w-5" />}
                    {index % 4 === 3 && <MapPin className="h-5 w-5" />}
                    {subsection.title}
                  </div>
                </div>
                {currentIdx === index ? (
                  <div className="collapse-content px-6 py-4 bg-white">
                    <div className="space-y-6">
                      {subsection.content.map((item, itemIndex) => (
                        <div key={itemIndex} className="mb-6">
                          {item.title && (
                            <h4 className="text-lg font-semibold text-gray-800 mb-2">
                              {item.title}
                            </h4>
                          )}
                          {item.description && (
                            <p className="text-gray-700 mb-4 whitespace-pre-line">
                              {item.description}
                            </p>
                          )}

                          {item.points && (
                            <div className="pl-4 space-y-2">
                              {item.points.map((point, pointIndex) => (
                                <div key={pointIndex} className="flex gap-2">
                                  <span className="text-blue-600 font-bold">
                                    •
                                  </span>
                                  <p className="text-gray-700">{point}</p>
                                </div>
                              ))}
                            </div>
                          )}

                          {item.subsections && (
                            <div className="space-y-4 mt-4">
                              {item.subsections.map((sub, subIndex) => (
                                <div
                                  key={subIndex}
                                  className="bg-gray-50 p-4 rounded-md"
                                >
                                  <h5 className="font-semibold text-gray-800 mb-2">
                                    {sub.title}
                                  </h5>
                                  {sub.description && (
                                    <p className="text-gray-700 mb-2">
                                      {sub.description}
                                    </p>
                                  )}
                                  {sub.points && (
                                    <ul className="list-disc list-inside text-gray-700 space-y-1 pl-2">
                                      {sub.points.map((point, pointIndex) => (
                                        <li key={pointIndex}>{point}</li>
                                      ))}
                                    </ul>
                                  )}
                                </div>
                              ))}
                            </div>
                          )}

                          {itemIndex < subsection.content.length - 1 && (
                            <div className="divider my-4"></div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="text-center mt-8">
        <p className="text-red-500 text-sm italic">
          (সংগঠনের সম্পূর্ণ গঠনতন্ত্র লিখিতভাবে সংরক্ষিত রয়েছে, এর মধ্যে সংগঠন
          পরিচিতি ও সদস্যপদের প্রয়োজনীয় ধারার আংশিক প্রকাশ করা হল)
        </p>
      </div>
    </div>
  );
};

export default Rules;
